import { RestClientAuthenticated } from '../network';
import {
  InvitationBasicDTO,
  InvitationDTO,
  InvitationLinkInfo,
  VerifiedInvitation,
} from './types/InvitationDTO';

const DEFAULT_URL = '/moncompte/invitations';

const invitationApi = {
  createInvitation: (entityId: string, invitationCreation: InvitationBasicDTO): Promise<InvitationDTO> => new RestClientAuthenticated(`${DEFAULT_URL}/entities/${entityId}`, 'POST', 'application/json')
    .jsonBody(invitationCreation)
    .execute(),
  deleteInvitation: (invitationId: string): Promise<void> => new RestClientAuthenticated(`${DEFAULT_URL}/${invitationId}`, 'DELETE', null)
    .execute(),
  renewInvitation: (invitationId: string): Promise<InvitationDTO> => new RestClientAuthenticated(`${DEFAULT_URL}/${invitationId}`, 'PUT', 'application/json')
    .execute(),
  verifyInvitationLink: (invitationLink: InvitationLinkInfo): Promise<VerifiedInvitation> => new RestClientAuthenticated(`${DEFAULT_URL}/verify`, 'POST', 'application/json')
    .jsonBody(invitationLink)
    .execute(),
  refuseInvitation: (invitationId: string): Promise<void> => new RestClientAuthenticated(`${DEFAULT_URL}/${invitationId}/refuse`, 'PUT', null)
    .execute(),
};

export default invitationApi;
